

const baseURL = process.env.REACT_APP_API_BASE_URL;
const baseDashboardURL = process.env.REACT_APP_DASHBOARD_BASE_URL;
const manualURL = process.env.REACT_APP_API_MANUAL_URL;
const manualURLNew = process.env.REACT_APP_API_MANUAL_NEW_URL;
//console.log(manualURL)
//console.log(manualURLNew)

 

export const APIConstants = {
  // * Request Types 
  GET: "get",
  PUT: "put",
  POST: "post", 
  DELETE: "delete",
  // GET_WITH_TOKEN: "getWithToken",
  API_BASE_URL: baseURL + "",
  API_MANUAL_URL: manualURL + "",



  
  // login signup apis 
  LOGIN_API: baseURL + "/GetRoleByLogin",
  VALIDATE_SCREEN_API: baseURL + "/GetScreenNameByRoleID",
  // LOGIN_API: baseURL + "/Login",
  SIGN_UP_API: baseURL + "/InsertNewUser",
  CHECK_OTP_API: baseURL + "/CheckOTP",
  UPDATE_USER_API: baseURL + "/UpdateUserOTP",
  UPDATE_PASSWORD_API: baseURL + "/Updatepassword",
  GET_LICENSE_DETAILS: baseURL + "/GetClintList",
  INSERT_LICENSE_DETAILS: baseURL + "/InsertClint",
  FLOW_MODULES :baseURL + "/FlowModuleDetails",

    GET_THEME_COLOR_DETAILS : manualURLNew+ "/GetThemeColorDetails",
  UPDATE_THEME_COLOR_DETAILS : manualURLNew+ "/UpdateThemeColorDetails",
// meters Count

METERS_COUNT:baseURL+"/GetOverlAllMeterCount",


  // API Paths(GROUPS)
  GET_APPLICATION_MODULE_DETAILS: baseURL + "/GetApplicationModulesDetails",
  GET_REPORT_STATUS_MASTER_DETAILS: baseURL + "/GetReportStatusMasterDetails",
 GET_FLOW_GROUP_DETAILS: baseURL + "/GetFlowGroupDetails", 
 INSERT_FLOW_GROUP_DETAILS: baseURL + "/InsertFlowGroupDetails",
 UPDATE_FLOW_GROUP_DETAILS: baseURL + "/UpdateFlowGroupDetails",
 DELETE_FLOW_GROUP_DETAILS: baseURL + `/DeleteFlowGroupDetails`,
//  http://20.244.40.160:81/DeleteFlowGroupDetails?GroupID=7&IsDelete=true


//API Paths(GROUP_METER)
GET_FLOW_GROUP_METER_DETAILS: baseURL + "/GetFlowGroupMeterDetails",
USP_LIST_SITES: baseURL + "/Getsites",
GET_GROUP_METER_NAME_DETAILS: baseURL +`/NSGetFlowConverterDetails`,
INSERT_FLOW_GROUP_METER_DETAILS: baseURL + "/InsertFlowGroupMeterDetails",
UPDATE_FLOW_GROUP_METER_DETAILS: baseURL + "/UpdateFlowGroupMeterDetails",
DELETE_FLOW_GROUP_METER_DETAILS: baseURL + `/DeleteFlowGroupMeterDetails`,


// API Paths(SUB_METER)
GET_FLOW_SUB_GROUPS_DETAILS:  baseURL + `/GetFlowSubGroupsDetails`,
GET_CALCULATION_TYPE_MASTER_DETAILS: baseURL + "/GetCalculationTypeMasterDetails",
INSERT_FLOW_SUB_GROUP_METER_DETAILS: baseURL + "/InsertFlowSubGroupsDetails",
UPDATE_FLOW_SUB_GROUP_METER_DETAILS:  baseURL + "/UpdateFlowSubGroupsDetails",
DELETE_FLOW_SUB_GROUP_METER_DETAILS:   baseURL + `/DeleteFlowSubGroupsDetails`,



//Electrical APIs
//tree dashboard data
TREE_CHART_DATA_QUERY: baseURL + "/TVSTreeDashBoardData",
ELECTRICAL_LIVE_CHART: baseURL + "/api/Electrical/LiveChart",
ELECTRICAL_COMPARATIVE_REPORT : baseURL + "/api/Electrical/ComparitiveData",
// ELECTRICAL_COMPARATIVE_REPORT : baseURL + "/api/Electrical/Comparitive",
ELECTRICAL_RAWDATA : baseURL + "/api/Electrical/RawData",
ELECTRICAL_PLOT_INTERVAL_DATA : baseURL + "/api/Electrical/ElePlotIntervalData",
ELECTRICAL_PLOT_DETAILS : baseURL + "/PlotDetails",
ELECTRICAL_FUNCTION_DETAILS : baseURL + "/FunctionDetails",




ELECTRICAL_HISTORICAL_REPORT : baseURL + "/api/Electrical/Historicaltrends",
ELECTRICAL_METER_STATUS : baseURL + "/api/Electrical/Meterstatus",
ELECTRICAL_PARAMETER_VIEW : baseURL + "/api/Electrical/Parmeterview",
ELECTRICAL_CONSUMPTION_REPORT : baseURL + "/api/Electrical/Consumptionreport",
ELECTRICAL_SHIFT_WISE_CONSUMPTION_REPORT : baseURL + "/api/Electrical/ShiftWiseConsumptionreport",
ELECTRICAL_METERS_LIST : baseURL + "/api/Electrical/MeterDetails",
ELECTRICAL_HISTORICAL_PARAMETERS_LIST : baseURL + "/api/Electrical/HistoricalParameters",
ELECTRICAL_METERS_DETAILS : baseURL + "/api/Electrical/MeterDetails",
ELECTRICAL_PARAMETER_DETAILS : baseURL + "/api/Electrical/LiveParameters",
ELECTRICAL_DATA_TYPE_DETAILS : baseURL + "/AllParameterDataTypeDetails",
ELECTRICAL_COVERTER_DETAILS : baseURL + "/api/Electrical/MeterDetails",
ELECTRICAL_INSERT_GROUP : baseURL + "/api/Electrical/InsertGroupDetails",
ELECTRICAL_INSERT_SUB_GROUP : baseURL + "/api/Electrical/insertsubgroupdetails",
ELECTRICAL_GROUP_DETAILS : baseURL + "/api/Electrical/Getgroupdetails",
ELECTRICAL_SUB_GROUP_DETAILS : baseURL + "/api/Electrical/GetSubGroupsDetails",
ELECTRICAL_GROUP_DELETE : baseURL + "/api/Electrical/Deletegroup",
ELECTRICAL_GROUP_DEVICE_DELETE : baseURL + "/api/Electrical/DeletegroupMeterDetails",
ELECTRICAL_SUB_GROUP_DELETE : baseURL + "/api/Electrical/Deletesubgroup",


// dash api 
// DashLive 
ELECTRICAL_DASHBOARD_METER_DETAILS : baseURL + "/InsertDashboardMeter",
ELECTRICAL_DELETE_DASHBOARD_METER_DETAILS : baseURL + "/DeleteDashboardMeterConfig",
ELECTRICAL_GET_DASHBOARD_METER_DETAILS : baseURL + "/DashboardMeterConfig",
ELECTRICAL_GET_PARAMETER_CONFIG_DETAILS: baseURL + "/api/Electrical/ParameterConfigDetails",
ELECTRICAL_POST_PARAMETER_CONFIG_DETAILS: baseURL + "/api/Electrical/ParameterConfigThreshold",
ELECTRICAL_UPDATE_PARAMETER_CONFIG_DETAILS: baseURL + "/api/Electrical/UpdateParameterConfigThreshold",
ELECTRICAL_DELETE_PARAMETER_CONFIG_DETAILS: baseURL + "/api/Electrical/DeleteParameterConfigThresholdRequest",



// Dash Energy 
ELECTRICAL_SHIFT_TIMING: baseURL + "/DashShiftTiming",
ELECTRICAL_UPDATE_SHIFT_TIMING: baseURL + "/UpdateDashShiftTiming",
ELECTRICAL_GET_DAY_STATUS: baseURL + "/api/Electrical/Getdaystatus",



// SLD Apis 
GET_NODE_DETAILS  : baseURL + "/api/Electrical/GetNodeDetails",
GET_EQUIPMENT_DETAILS  : baseURL + "/api/Electrical/GetEquipmentTypeMaster",
GET_PARAMETER_TYPE: baseURL + "/api/Electrical/GetParametersType",
GET_MASTER_SLD_DETAILS: baseURL + "/api/Electrical/GetNodeDetails",
GET_SLD_DATA: baseURL + "/api/Electrical/GetSLDScreenDetails",
INSERT_SLD_DATA: baseURL + "/api/Electrical/InsertSLDDetails",
DELETE_SLD_DATA: baseURL + "/api/Electrical/DeleteSLDDetails",
GET_NODE_METER_DEATILS: baseURL + "/api/Electrical/GetNodeMeterDetails",
UPDATE_SLD_DATA: baseURL + "/api/Electrical/UpdateSLDDetails",




// main electrical dashboard
ELECTRICAL_DASHBOARD_POWER_DEMAND: baseURL + "/DashboardPowerDemand",
ELECTRICAL_DASHBOARD_PLANT_CURVE_DATA: baseURL + "/PlantLoadCurveData",
ELECTRICAL_DASHBOARD_ENERGY_CONSUMPTION: baseURL + "/DashBoardDonutEnergyConsumption",
ELECTRICAL_DASHBOARD_DONUT_COSTING: baseURL + "/DashBoardDonutCosting",
ELECTRICAL_YESTERDAY_SLOT_CONSUMPTION: baseURL + "/YesterdaySlotConsumption",
ELECTRICAL_MTD_SLOT_CONSUMPTION: baseURL + "/MTDSlotConsumption",
ELECTRICAL_RENEWABLE_CONSUMPTION: baseURL + "/RenewableConsumption",
DASHBOARD_SANKEY: baseURL + "/GettSankeyDashBoardDataAsync",
DASHBOARD_SANKEY_GAS: baseURL + "/GetFlowSankeyDashBoardDataAsync",






ELECTRICAL_INSERT_LOGO_IMAGE: baseURL + "/UpdateLoginLogoAndImage",
ELECTRICAL_GET_LOGO_IMAGE: baseURL + "/GetImageDetails",
ELECTRICAL_GET_ALERTS: baseURL + "/GetAllAlert",
ELECTRICAL_INSERT_SUB_CATEGORY: baseURL + "/InsertEmailSubCatagory",
ELECTRICAL_INSERT_RECEPIENT: baseURL + "/InsertRecipients",
ELECTRICAL_GET_SUB_CATEGORY: baseURL + "/EmailSubCatagory",
ELECTRICAL_GET_SCREENS: baseURL + "/AllEMSContextMenuDetails",
ELECTRICAL_GET_ROLES: baseURL + "/GetRole",
ELECTRICAL_GET_ROLE_ACTIONS: baseURL + "/GetAllRoleAction",
ELECTRICAL_GET_RECIPIENTS: baseURL + "/GetEmailRecipient",
ELECTRICAL_INSERT_ROLES: baseURL + "/insertRole",
ELECTRICAL_UPDATE_ROLES: baseURL + "/UpdateRoleByRoleId",
ELECTRICAL_DELETE_ROLES: baseURL + "/DeleteRole",
ELECTRICAL_DELETE_SUB_CATEGORY: baseURL + "/DeleteSubCatagory",
ELECTRICAL_INSERT_ROLE_ACTIONS: baseURL + "/insertroleActionsnew",


ELECTRICAL_GET_USER: baseURL + "/GetAllUserRegistration",
ELECTRICAL_INSERT_USER: baseURL + "/InsertUserRegistration",
ELECTRICAL_UPDATE_USER: baseURL + "/UpdateUserRegistrationById",
ELECTRICAL_DELETE_USER: baseURL + "/DeleteUserDetails",







ELECTRICAL_INSERT_TARIFF_DETAILS: baseURL + "/api/Electrical/InsertTariffDetailsRequest",
ELECTRICAL_GET_TARIFF_DETAILS: baseURL + "/api/Electrical/TariffDetails",
ELECTRICAL_DELETE_TARIFF_DETAILS: baseURL + "/api/Electrical/DeleteTariffDetailsRequest",
ELECTRICAL_UPDATE_TARIFF_DETAILS: baseURL + "/api/Electrical/UpdateTariffDetailsRequest",


ELECTRICAL_INSERT_TARIFF_SLOT_DETAILS: baseURL + "/api/Electrical/InsertTariffSlotDetails",
ELECTRICAL_UPDATE_TARIFF_SLOT_DETAILS: baseURL + "/api/Electrical/UpdateTariffSlot",
ELECTRICAL_GET_TARIFF_SLOT_DETAILS: baseURL + "/api/Electrical/GetTariffSlotDetails",
ELECTRICAL_DELETE_TARIFF_SLOT_DETAILS: baseURL + "/api/Electrical/DeleteTariffSlot",




ELECTRICAL_GROUP_NAME: baseURL + "/api/Electrical/Getgroupdetails",
ELECTRICAL_CONSUMPTION_DETAILS : baseURL + "/api/Electrical/Getparameters",
ELECTRICAL_SUB_GROUPDETAILS : baseURL + "/api/Electrical/GetSubGroupsDetails",
ELECTRICAL_GROPU_REPORT : baseURL + "/api/Electrical/Getgroupreport",
ELCTRICAL_METER_DETAILS : baseURL +"/api/Electrical/GetGroupMeterDetails",
ELCTRICAL_SUBGROUP_METER_DETAILS : baseURL +"/api/Electrical/GroupMeterReport",
ELECTRICAL_INSERT_GROUP_DETAILS : baseURL + "/api/Electrical/insertGroupMeterDetails",
ELECTRICAL_GROUP_METER_DETAILS : baseURL + "/api/Electrical/GetGroupMeterDetails",









//reset childern and entity data
RESET_CALCULATIONS_MUTATION: baseURL + "/DeleteEntityAndChildMeter", 



//Plant Chart APIs
TVS_GET_DEPARTMENTS: baseURL + "/GetDepartments",
GET_PLANT_NAME : baseURL + "/Getplantname",
GET_CHART_CONTROL :baseURL + "/Getchartcontrol",
GET_COMBINED_PLANT_DATA : baseURL + "/GetCombinedPlantData",
INSERT_PLANT_NAMES :baseURL + "/InsertplantNames",
INSERT_PLANT_NAME_DETAILS : baseURL + "/InsertplantNamesdetails",
DELETE_PLANT_NAME_DETAILS :baseURL + "/DeletePlantNamedetails",
DELETE_PLANT_NAME_MASTER :baseURL +"/DeletePlantNamemaster",
UPDATE_PLANT_NAME_DETAILS :baseURL + "/UpdatePlantNamedetails",
UPDATE_PLANT_NAME_MASTER :baseURL + "/UpdatePlantNamemaster",




//Live chart APIs
GET_FLOW_CONVERTER_DETAILS :baseURL + "/GetFlowConverterDetails",
GET_ELECTRICAL_CONVERTER_DETAILS :baseURL + "/GetConverterDetails",
GET_FLOW_SECTION_MASTER :baseURL + "/GetFlowSectionMaster",
GET_FLOW_STEAM_GROUP_METER_DETAILS: baseURL + "/GetFlowSteamGropeMeterDetails",
GET_STEAM_CONVERTER_LIVE_CHART:baseURL + "/GetsteamConverterLiveChart",
GET_STEAM_METER_STATUS_DETAILS: baseURL + "/GetsteamMeterStatusDetails",


// Steam Layout API 
GET_STEAM_DASHBOARD_DATA : baseURL + "/TVSTreeDashBoardSteamData",  
GET_STEAM_AGGREGATION_PERIOD  : baseURL + "/GetAggregationPeriod",
GET_TREE_CHART_DATA : baseURL + "/TVSTreeDashBoardData",
GET_STEAM_METER_STATUS_DETAILS : baseURL + "/GetsteamMeterStatusDetails",
GET_FLOW_SECTION_MASTER_DETAILS : baseURL + "/GetFlowSectionMaster",
GET_FLOW_NS_CONVERTER_DETAILS : baseURL + "/NSGetFlowConverterDetails",
GET_FLOW_CONVERTER_DETAILS :baseURL +"/GetFlowConverterDetails",
GET_FLOW_STEAM_GROUP_METER_DETAILS : baseURL +  "/GetFlowSteamGropeMeterDetails",
GET_STEAM_CONVERTER_LIVE_CHART :baseURL + "/GetsteamConverterLiveChart",









GET_STEAM_FLOW_GROUP_DETAILS : baseURL +  "/GetFlowGroupDetails",
GET_TVS_GAUGE_DASHBOARD_DATA :baseURL + "/GetTVSGauageDashboardData",//gauge chart api 
GET_STEAM_DASHBOARD_CONVERTOR_STATUS : baseURL + "/ConverterStaus",
GET_STEAM_DASHBOARD_COMPARATIVE_DATA : baseURL + "/Getsteamcomparativedata",
GET_STEAM_DASHBOARD_RAWDATA_DETAILS : baseURL + "/GetsteamRawDataDetails", 
GET_STEAM_DASHBOARD_HISTORICAL_DETAILS : baseURL + "/GetsteamHistoricalDetails",
STEAM_GROUP_CONSUMPTION_REPORT : baseURL + "/SteamGroupConsumption",
STEAM_CONVERTOR_CONSUMPTION_REPORT : baseURL + "/SteamConverterConsumption",





//WATER APIS
GET_LIVE_CHART_DATA_WATER : baseURL + "/GetWaterConverterLiveChart",
GET_FLOW_CONVERTER_DETAILS_WATER : baseURL + "/GetWaterConverterStaus",
GET_FLOW_SECTION_MASTER_DETAILS_WATER : baseURL + "/GetFlowSectionMaster",
GET_GROUP_DETAILS_WATER: baseURL + "/GetWaterGroupDetails",
GET_METER_STATUS_DETAILS_WATER: baseURL +  "/GetWaterMeterStatusDetails",
GET_RAW_DATA_WATER: baseURL + "/GetWaterRawDataDetails",
GET_HISTORICAL_DETAILS_WATER : baseURL + "/GetWaterHistoricalDetails",
GET_COMPARITIVE_REPORT_WATER : baseURL + "/WaterMeterDataDetailsForComparitive",
GET_COMPARITIVE_GROUP_WATER : baseURL + "/ConsumptionforGroup",
GET_COMPARITIVE_CONVERTER_WATER : baseURL + "/Consumptionforconverter",



//AIR APIS
GET_LIVE_CHART_AIR :baseURL + "/api/Air/GetAirLivechart",
GET_METER_STATUS_AIR : baseURL +"/api/Air/GetAirMeterstatus",
GET_CONVERTOR_STATUS_AIR :baseURL + "/api/Air/GetAirConverterStatus",
GET_COMPARATIVE_REPORT : baseURL + "/api/Air/AirComparitive",
GET_AIR_RAW_DATA :baseURL + "/api/Air/AirRawData",
GET_AIR_HISTORICAL_DATA : baseURL + "/api/Air/GetAirHistorical",
GET_CONSUMPTION_REPORT_AIR_CONVERTER : baseURL + "/api/Air/AirConsumptionforconverter",
GET_CONSUMPTION_REPORT_AIR_GROUP : baseURL + "/api/Air/AirConsumptionforGroup",




//TEMPERATURE APIS
GET_LIVE_TRENDS_TEMPERATURE :baseURL + "/Livetemperature",
GET_METER_STATUS_TEMPERATURE :baseURL + "/MeterStatustemp",
GET_CONVERTER_STATUS_TEMPERATURE :baseURL + "/convertertemp",
GET_COMPARATIVE_TEMPERATURE :baseURL + "/TempComparitive",
GET_RAWDATA_TEMPERATURE :baseURL + "/Rawdatatemp",
GET_CONSUMPTION_TEMPERATURE :baseURL + "/consumptiontemp",
GET_HISTORICAL_TRENDS_TEMPERATURE :baseURL + "/Histtrendstemp",
TEMP_METERS_LIST : baseURL + "/tempmeterdetails",
TEMP_GETSITES : baseURL + "/Getsites",

// Confirguration
GET_CONFIG_CONVERTER : baseURL + "/GetConverterDetails",
GET_MODULES : baseURL + "/GetModule",
CONFIG_INSERT_CONVERTER : baseURL + "/InsertConverterdetails",
DELETE_CONFIG_CONVERTER: baseURL +"/DeleteConverterDetails",
CONFIG_INSERT_METER: baseURL + "/InsertDevicedetails",
DELETE_CONFIG_METER : baseURL + "/DeleteMeterDetails",
UPDATE_CONFIG_METER: baseURL + "/UpdateDevicedetails",
GET_CONFIG_METER : baseURL + "/GetDeviceDetails",
GET_METER_LOCATION : baseURL + "/DeviceLocation",
GET_METER_MODAL_DETAILS : baseURL + "/GetMeterModel",
GET_DEVICES_DETAILS : baseURL + "/GetSupplierList",
DELETE_DEVICE_DETAILS: baseURL + "/DeleteDeviceDetails",




INSERT_ENERGY_SOURCE_MANUAL_ENTRY: manualURL + "/InsertEnergySourceManualEntry",
GET_ENERGY_SOURCE_MANUAL_ENTRY: manualURL + "/GetEnergySourceManualEntry",
DELETE_ENERGY_SOURCE_MANUAL_ENTRY: manualURL + "/DeleteEnergySourceManualEntry",

GET_EMISSION_FACTOR_MANUAL_ENTRY: manualURL + "/GetEmissionFactorManualEntry",
INSERT_GET_EMISSION_FACTOR_MANUAL_ENTRY: manualURL + "/UpdateEmissionFactorManualEntry",

SMML_LIVE_POWER_STATISTICS: manualURL + "/SmmlLivePowerStatistics",
SMML_SEC_STATISTICS_CONSUMPTION: manualURL + "/SMMLSECStatisticsConsumption",
SMML_SEC_STATISTICS_ENERGY_CONSUMPTION: manualURL + "/SMMLConsumptionEnergyStatistics",
SMML_DONUT_CONSUMPTION: manualURL + "/SMMLDonutConsumption",
SMML_ENERGY_GROUP_ID: manualURL + "/SMMLEnergyGroupIDs",
















// dashboard apis 
LUCAS_LIVE_GAUGE : baseDashboardURL+ "/LucasLiveGauges",
  LUCAS_LIVE_DATA_TABLE : baseDashboardURL+ "/Livedata",
  LUCAS_LIVE_PLNAT_DEMAND_DETAILS : baseDashboardURL+ "/plantdemanddetails",
  LUCAS_LIVE_DAILY_CONSUMPTION : baseDashboardURL+ "/LucasDailyConsumption",
  LUCAS_LIVE_KWT : baseDashboardURL+ "/GetLiveKwtvalue",
  LUCAS_LIVE_HOURLY_CONSUMPTION : baseDashboardURL+ "/LucasHourlyConsumption",
  LUCAS_LIVE_WEEKLY_CONSUMPTION : baseDashboardURL+ "/LucasWeeklyConsumption",
  LUCAS_LIVE_11kv_CONSUMPTION : baseDashboardURL+ "/Lucas11KvVCBConsumptiontrend",
  LUCAS_LIVE_TRANSFORMER_CONSUMPTION : baseDashboardURL+ "/LucasTransformersVCBConsumptiontrend",
  LUCAS_SF6VCB_CONSUMPTION : baseDashboardURL+ "/SF6VCBConsumptiontrend",
  LUCAS_TOOL_ROOM : baseDashboardURL+ "/ToolRoomConsumptiontrend",
  LUCAS_PHOSPHATING : baseDashboardURL+ "/PhosphatingConsumptiontrend",
  DG_CONSUMPTION : baseDashboardURL+ "/Dgconsumption",
  DG_LIVE : baseDashboardURL+ "/dglivedata",
  PRODUCTION_DATA : baseDashboardURL+ "/ProductionDataDetails",
  GAUGES_LIVE_VOLTAGE : baseDashboardURL+ "/GetGaugesLiveVoltage",
  GAUGES_LIVE_DEMAND : baseDashboardURL+ "/GetGaugesLiveDemand",
  GAUGES_LIVE_CURRENT : baseDashboardURL+ "/GetGaugeLiveCurrent",
  GAUGES_LIVE_POWER_FACTOR : baseDashboardURL+ "/GetGaugeLivePowerFactor",
  UPDATE_GAUGE_DETAILS : baseDashboardURL+ "/UpdateDashBoardGaugeDetails",


  // New Manual screen 


  INSERT_MANUAL_ENTRY_DATA: manualURLNew + "/InsertManualEntry",
GET_MANUAL_ENTRY_DATA: manualURLNew + "/GetManualDetails",



    INSERT_EXTERNAL_ENERGY_SOURCE : manualURLNew+ "/InsertExternalEnergySource",
    UPDATE_EXTERNAL_ENERGY_SOURCE : manualURLNew+ "/UpdateExternalEnergySource",
    GET_EXTERNAL_ENERGY_SOURCE : manualURLNew+ "/GetExternalEnergySources",
    DELETE_EXTERNAL_ENERGY_SOURCE : manualURLNew+ "/DeleteExternalEnergySource",
    INSERT_PRODUCTION_DATA : manualURLNew+ "/InsertProductionData",
    GET_PRODUCTION_DATA : manualURLNew+ "/GetProductionData",
    DELETE_PRODUCTION_DATA : manualURLNew+ "/DeleteProductionData",
    INSERT_EMISSION_DATA : manualURLNew+ "/InsertEmissionDetail",
    GET_EMISSION_DATA : manualURLNew+ "/GetEmissionDetails",
    DELETE_EMISSION_DATA : manualURLNew+ "/DeleteEmissionDetail",
    DELETE_MANUAL_ENTRY : manualURLNew+ "/DeleteManualEntrys",
    VALIDATE_MANUAL_ENTRY : manualURLNew+ "/Validation",
    
    
    
    
    GET_CONVERTER_AND_DEVICE_STATUS : manualURLNew+ "/GetConvertersAndDeviceStatusCount",
    GET_CONVERTER_DEVICE_STATUS : manualURLNew+ "/api/Electrical/GetConverterkDeviceCountStatus",
    GET_GROUP_DEVICE_STATUS : manualURLNew+ "/api/Electrical/GroupkDeviceCountStatus",
    GET_CONVERTER_DEVICE_DETAILS : manualURLNew+ "/api/Electrical/MeterStatusDetails",

     //meter filterd based on idle or off
    GET_METER_POPUP_DETAILS : manualURLNew+ "/api/Electrical/MeterStatusPopUpDetails",
    PARAMETERS_LIST_FOR_HARMONICS:manualURLNew+"/api/Electrical/GetHarmonicParameters"


};



